import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { Dokter, Unit } from "@/types";
import ResepObatSvc from "@/services/ResepObat";

interface ResepRaw {
  id: number;
  text: string;
  depo_id: string;
  bb: number;
  alergi: string;
  diagnosis: string;
  // dr_id: number;
  dokter: Dokter;
  // unit_id: string;
  unit: Unit;
  // pasien_cm: number;
  pasien: object;
  register_id: number;
  status: number;
  tanggal: string;
  items: [];
  resep_racikan?: [];
  created_at: string;
}

interface Resep {
  id: number;
  text: string;
  depo_id: string;
  bb: number;
  alergi: string;
  diagnosis: string;
  // dr_id: number;
  dokter: Dokter;
  // unit_id: string;
  unit: Unit;
  // pasien_cm: number;
  pasien: object;
  register_id: number;
  status: number;
  tanggal: string;
  items: [];
  created_at: string;
}

@Module({ store, dynamic: true, name: "order-bmhp", namespaced: true })
class OrderBmhpStore extends VuexModule {
  public orderRaw: Array<ResepRaw> = [];
  public listLoading = false;

  public get order(): Resep[] {
    const order = this.orderRaw.map(raw => {
      if (Object.hasOwnProperty.call(raw, "resep_racikan")) {
        const { resep_racikan, ...restResep } = raw;

        // @ts-ignore
        restResep.items = [...restResep.items, ...resep_racikan];

        return restResep;
      } else {
        return raw;
      }
    });

    return order;
  }

  @Mutation
  public SET_RESEP(data: Array<ResepRaw>): void {
    this.orderRaw = data;
  }

  @Mutation
  public SET_LIST_LOADING(data: boolean): void {
    this.listLoading = data;
  }

  @Action getOrderByRegister(reg) {
    this.SET_LIST_LOADING(true);

    ResepObatSvc.getOrderBmhpByRegister(reg)
      .then(resp => {
        // console.log("get order bmhp", resp.data);
        const data = resp.data.data.filter(item => item.kategori === "a");

        // console.log("return", data);

        this.SET_RESEP(data);
      })
      .finally(() => {
        this.SET_LIST_LOADING(false);
      });
  }
}

export const orderBmhpStore = getModule(OrderBmhpStore);
